import { Loader, LoaderStyle } from "@repo/ui/Loader/loader";
import type { FC } from "react";
import { Navigate } from "react-router";
import { useGenesysDetailOutletContext } from "./genesysIntegrationDetailSection.js";
import { RecordingImportsTab } from "./recordingImportsTab.js";

/**
 * The **Failed imports** tab of the Genesys detail: the generic
 * recording-imports surface over this company's Genesys integration row.
 */
export const GenesysRecordingImportsTab: FC = () => {
  const { integration, isLoading } = useGenesysDetailOutletContext();
  if (!integration) {
    // On a direct visit the integration is still loading; redirecting on that
    // transient `null` would bounce every deep link back to Settings.
    if (isLoading) {
      return <Loader style={LoaderStyle.SPINNER} />;
    }
    // ".." is the parent route: "." would resolve to this child and stay put.
    return <Navigate to=".." replace />;
  }
  return (
    <RecordingImportsTab
      integrationId={integration.id}
      provider={integration.provider}
      // A paused integration's rows wait unclaimed, and the API refuses both
      // reprocess and skip (400), so the tab hides the actions instead.
      isPaused={!integration.settings.is_enabled}
      description="Recordings that couldn't be imported from Genesys Cloud. Reprocess a failed or skipped recording to try importing it again, or skip a failed one to dismiss it."
    />
  );
};
